import {
  Unit_instanceat14thlj150z as Unit_instance,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  VOID7hggqo3abtya as VOID,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  toDuration7gy6v749ektt as toDuration,
  coerceIn10f36k81le1mm as coerceIn,
  copyOfRange3alro60z4hhf8 as copyOfRange,
  indexOfj0u699sj4o53 as indexOf,
  copyOfwy6h3t5vzqpl as copyOf,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  toByte4i43936u611k as toByte,
  toLongw1zpgk99d84b as toLong,
  Long2qws0ah9gnpki as Long,
  coerceIn302bduskdb54x as coerceIn_0,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  Paire9pteg33gng7 as Pair,
  until1jbpn0z3f8lbg as until,
  ClosedRangehokgr73im9z3 as ClosedRange,
  contains2c50nlxg7en7o as contains,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  createThis2j2avj17cvnv2 as createThis,
  printStackTrace18lnx7a39cni as printStackTrace,
  RuntimeException1r3t0zl97011n as RuntimeException,
  toString30pk9tzaqopn as toString_0,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  decodeToString1x4faah2liw2p as decodeToString,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Channel3r72atmcithql as Channel,
  delay1blitpytzu6gr as delay,
  withContext3ioifgw29h7cj as withContext,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  launch1c91vkjzdi9sd as launch,
  Mutex16li1l0asjv17 as Mutex,
} from './kotlinx-coroutines-core.mjs';
import {
  ilog23dbvpk38jf7rc as ilog2,
  nextAlignedTo3ni8b2boh3zjg as nextAlignedTo,
  toIntClampad53d0g5q5oi as toIntClamp,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  SimpleBytesDeque3uob1f4dosqej as SimpleBytesDeque,
  SimpleChunkedByteDeque3cr64mogfywgm as SimpleChunkedByteDeque,
  getS83kqgdtkseh4fp as getS8,
  getU83agrw8yj0shar as getU8,
  getS16BE6c2odqehs5au as getS16BE,
  getU16BE2rszf3doox5o as getU16BE,
  getU24BE36pml41y2814b as getU24BE,
  getS32BE5aphh7sm8f2q as getS32BE,
  getS64BE1b3e93qe1xjxx as getS64BE,
  getS8Array1clq6jd2z5jh9 as getS8Array,
  getS16ArrayBE3bj6gsad0tz3k as getS16ArrayBE,
  getU16ArrayBE1cpolqhg4wxps as getU16ArrayBE,
  getS32ArrayLE2u84ix7qnexrb as getS32ArrayLE,
  getS32ArrayBE30ehj217529qp as getS32ArrayBE,
  getS32LE1pxm9wohin3g8 as getS32LE,
  getU16LE2cizldw8qp53x as getU16LE,
  arraycopy3czrd9re36wzt as arraycopy,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  OutOfBoundsException1k0x58dcca6fx as OutOfBoundsException,
  Endian_LITTLE_ENDIAN_getInstance29hybk19wzxil as Endian_LITTLE_ENDIAN_getInstance,
  ByteArrayBuilderyrflhqjz64ju as ByteArrayBuilder,
  EOFExceptiona2wwqnj55hh5 as EOFException,
  invalidOp1stebxh2m3n07 as invalidOp,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  toString2x583ovdqfjci as toString_1,
  get_UTF82geyfhi1l22xl as get_UTF8,
} from './korlibs-string-root-korlibs-string.mjs';
import { Mixin3lmkm5hum2vdj as Mixin } from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class AsyncOutputStream {}
function write$default(buffer, offset, len, $completion, $super) {
  offset = offset === VOID ? 0 : offset;
  len = len === VOID ? buffer.length - offset | 0 : len;
  return $super === VOID ? this.p1p(buffer, offset, len, $completion) : $super.p1p.call(this, buffer, offset, len, $completion);
}
class AsyncRingBuffer {
  constructor(bufferSize) {
    bufferSize = bufferSize === VOID ? 1024 : bufferSize;
    this.j1p_1 = bufferSize;
    this.k1p_1 = null;
    this.l1p_1 = Channel(-1);
    this.m1p_1 = Channel(-1);
    this.n1p_1 = new SimpleBytesDeque(ilog2(this.j1p_1) + 1 | 0);
    this.o1p_1 = false;
  }
  p1p(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l.bind(VOID, this, buffer, offset, len), $completion);
  }
  r1p(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe.bind(VOID, this, buffer, offset, len), $completion);
  }
  s1p($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_close__nh2uv0.bind(VOID, this), $completion);
  }
  toString() {
    return 'AsyncByteArrayDeque(' + this.k1p_1 + ')';
  }
}
class Companion {
  constructor() {
    this.t1p_1 = 8388608;
  }
}
class AsyncRingBufferChunked {
  constructor(maxSize) {
    maxSize = maxSize === VOID ? 8388608 : maxSize;
    this.u1p_1 = maxSize;
    this.v1p_1 = null;
    this.w1p_1 = new SimpleChunkedByteDeque();
    this.x1p_1 = false;
  }
  p1p(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_0.bind(VOID, this, buffer, offset, len), $completion);
  }
  r1p(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_0.bind(VOID, this, buffer, offset, len), $completion);
  }
  s1p($completion) {
    this.x1p_1 = true;
  }
  toString() {
    return 'AsyncByteArrayDequeV2(' + this.v1p_1 + ')';
  }
}
class FastByteArrayInputStream {
  constructor(ba, offset, start, end) {
    offset = offset === VOID ? 0 : offset;
    start = start === VOID ? 0 : start;
    end = end === VOID ? ba.length : end;
    this.y1p_1 = ba;
    this.z1p_1 = start;
    this.a1q_1 = end;
    this.b1q_1 = offset + this.z1p_1 | 0;
  }
  c1q(value) {
    this.b1q_1 = this.z1p_1 + value | 0;
  }
  d1q() {
    return this.b1q_1 - this.z1p_1 | 0;
  }
  a() {
    return this.a1q_1 - this.z1p_1 | 0;
  }
  aw() {
    return this.a1q_1 - this.b1q_1 | 0;
  }
  gw() {
    return this.aw() > 0;
  }
  e1q(_this__u8e3s4) {
    return coerceIn(_this__u8e3s4, this.z1p_1, this.a1q_1);
  }
  f1q(size) {
    var out = this.g1q(this.d1q(), size);
    this.b1q_1 = this.b1q_1 + size | 0;
    return out;
  }
  h1q(offset) {
    return new FastByteArrayInputStream(this.y1p_1, 0, this.e1q(this.z1p_1 + offset | 0), this.a1q_1);
  }
  i1q(offset, $super) {
    offset = offset === VOID ? 0 : offset;
    return $super === VOID ? this.h1q(offset) : $super.h1q.call(this, offset);
  }
  wx() {
    return new FastByteArrayInputStream(this.y1p_1, this.d1q(), this.z1p_1, this.a1q_1);
  }
  g1q(offset, len) {
    return new FastByteArrayInputStream(this.y1p_1, 0, this.e1q(this.z1p_1 + offset | 0), this.e1q((this.z1p_1 + offset | 0) + len | 0));
  }
  lw(count) {
    this.b1q_1 = coerceIn(this.b1q_1 + count | 0, this.z1p_1, this.a1q_1);
  }
  j1q(count) {
    return this.lw(-count | 0);
  }
  k1q(len) {
    var out = copyOfRange(this.y1p_1, this.b1q_1, this.b1q_1 + len | 0);
    this.b1q_1 = this.b1q_1 + len | 0;
    return out;
  }
  l1q() {
    return getS8(this.y1p_1, offset(this, 1));
  }
  m1q() {
    return getU8(this.y1p_1, offset(this, 1));
  }
  n1q() {
    return getS16BE(this.y1p_1, offset(this, 2));
  }
  o1q() {
    return getU16BE(this.y1p_1, offset(this, 2));
  }
  p1q() {
    return getU24BE(this.y1p_1, offset(this, 3));
  }
  q1q() {
    return getS32BE(this.y1p_1, offset(this, 4));
  }
  r1q() {
    return getS64BE(this.y1p_1, offset(this, 8));
  }
  s1q(count) {
    return getS8Array(this.y1p_1, offset(this, count), count);
  }
  t1q(count) {
    return getS16ArrayBE(this.y1p_1, offset(this, imul(count, 2)), count);
  }
  u1q(count) {
    return getU16ArrayBE(this.y1p_1, offset(this, imul(count, 2)), count);
  }
  v1q(count) {
    return getS32ArrayLE(this.y1p_1, offset(this, imul(count, 4)), count);
  }
  w1q(count) {
    return getS32ArrayBE(this.y1p_1, offset(this, imul(count, 4)), count);
  }
  x1q(offset, length, charset) {
    var start = this.z1p_1 + offset | 0;
    var end = start + length | 0;
    return toString_1(this.y1p_1, charset, start, end);
  }
  y1q(len, charset) {
    var res = this.s1q(len);
    var index = indexOf(res, 0);
    return toString_1(copyOf(res, index < 0 ? len : index), charset);
  }
  z1q(len, charset, $super) {
    charset = charset === VOID ? get_UTF8() : charset;
    return $super === VOID ? this.y1q(len, charset) : $super.y1q.call(this, len, charset);
  }
}
class toAsync$o$write$slambda {
  constructor(this$0, $buffer, $offset, $len) {
    this.c1r_1 = this$0;
    this.d1r_1 = $buffer;
    this.e1r_1 = $offset;
    this.f1r_1 = $len;
  }
  g1o($this$withContext, $completion) {
    this.c1r_1.a1r_1.d14(this.d1r_1, this.e1r_1, this.f1r_1);
    return Unit_instance;
  }
  vd(p1, $completion) {
    return this.g1o((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class toAsync$o$close$slambda {
  constructor(this$0) {
    this.g1r_1 = this$0;
  }
  g1o($this$launch, $completion) {
    // Inline function 'korlibs.io.stream.<no name provided>.close.<anonymous>' call
    var tmp = this.g1r_1.a1r_1;
    var tmp7_safe_receiver = isInterface(tmp, AutoCloseable) ? tmp : null;
    if (tmp7_safe_receiver == null)
      null;
    else {
      tmp7_safe_receiver.f6();
    }
  }
  vd(p1, $completion) {
    return this.g1o((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class toAsync$1 {
  constructor($this_toAsync, $dispatcher) {
    this.b1r_1 = $dispatcher;
    this.a1r_1 = $this_toAsync;
  }
  p1p(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_1.bind(VOID, this, buffer, offset, len), $completion);
  }
  s1p($completion) {
    var dispatcher = this.b1r_1;
    if (!(dispatcher == null)) {
      var tmp = CoroutineScope_0(dispatcher);
      launch(tmp, VOID, VOID, toAsync$o$close$slambda_1(this));
    } else {
      // Inline function 'korlibs.io.stream.<no name provided>.close.<anonymous>' call
      var tmp_0 = this.a1r_1;
      var tmp7_safe_receiver = isInterface(tmp_0, AutoCloseable) ? tmp_0 : null;
      if (tmp7_safe_receiver == null)
        null;
      else {
        tmp7_safe_receiver.f6();
      }
    }
    return Unit_instance;
  }
}
class toAsync$o$read$slambda {
  constructor(this$0, $buffer, $offset, $len) {
    this.j1r_1 = this$0;
    this.k1r_1 = $buffer;
    this.l1r_1 = $offset;
    this.m1r_1 = $len;
  }
  g1o($this$withContext, $completion) {
    // Inline function 'korlibs.io.stream.<no name provided>.read.<anonymous>' call
    return this.j1r_1.h1r_1.y13(this.k1r_1, this.l1r_1, this.m1r_1);
  }
  vd(p1, $completion) {
    return this.g1o((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class toAsync$o$close$slambda_0 {
  constructor(this$0) {
    this.n1r_1 = this$0;
  }
  g1o($this$launch, $completion) {
    // Inline function 'korlibs.io.stream.<no name provided>.close.<anonymous>' call
    var tmp = this.n1r_1.h1r_1;
    var tmp4_safe_receiver = isInterface(tmp, AutoCloseable) ? tmp : null;
    if (tmp4_safe_receiver == null)
      null;
    else {
      tmp4_safe_receiver.f6();
    }
  }
  vd(p1, $completion) {
    return this.g1o((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class toAsync$o$getPosition$slambda {
  constructor(this$0) {
    this.o1r_1 = this$0;
  }
  g1o($this$withContext, $completion) {
    // Inline function 'korlibs.io.stream.<no name provided>.getPosition.<anonymous>' call
    var tmp = this.o1r_1.h1r_1;
    var tmp5_safe_receiver = isInterface(tmp, SyncPositionStream) ? tmp : null;
    return tmp5_safe_receiver == null ? null : tmp5_safe_receiver.d1q();
  }
  vd(p1, $completion) {
    return this.g1o((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class toAsync$o$getLength$slambda {
  constructor(this$0) {
    this.p1r_1 = this$0;
  }
  g1o($this$withContext, $completion) {
    // Inline function 'korlibs.io.stream.<no name provided>.getLength.<anonymous>' call
    var tmp = this.p1r_1.h1r_1;
    var tmp6_safe_receiver = isInterface(tmp, SyncLengthStream) ? tmp : null;
    return tmp6_safe_receiver == null ? null : tmp6_safe_receiver.a();
  }
  vd(p1, $completion) {
    return this.g1o((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class AsyncGetLengthStream {}
function hasLength($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_hasLength__5f5ox8.bind(VOID, this), $completion);
}
function getLength($completion) {
  throw UnsupportedOperationException.d8();
}
class AsyncGetPositionStream {}
function getPosition($completion) {
  throw UnsupportedOperationException.d8();
}
class toAsync$2 {
  constructor($this_toAsync, $dispatcher) {
    this.i1r_1 = $dispatcher;
    this.h1r_1 = $this_toAsync;
  }
  r1p(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_1.bind(VOID, this, buffer, offset, len), $completion);
  }
  s1p($completion) {
    var dispatcher = this.i1r_1;
    if (!(dispatcher == null)) {
      var tmp = CoroutineScope_0(dispatcher);
      launch(tmp, VOID, VOID, toAsync$o$close$slambda_2(this));
    } else {
      // Inline function 'korlibs.io.stream.<no name provided>.close.<anonymous>' call
      var tmp_0 = this.h1r_1;
      var tmp4_safe_receiver = isInterface(tmp_0, AutoCloseable) ? tmp_0 : null;
      if (tmp4_safe_receiver == null)
        null;
      else {
        tmp4_safe_receiver.f6();
      }
    }
    return Unit_instance;
  }
  q1r($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getPosition__nbsewl.bind(VOID, this), $completion);
  }
  r1r($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getLength__lvva94.bind(VOID, this), $completion);
  }
}
class AsyncStreamBase {
  static g1s($box) {
    return createThis(this, $box);
  }
  z1r(position, buffer, offset, len, $completion) {
    throw UnsupportedOperationException.d8();
  }
  h1s(position, buffer, offset, len, $completion) {
    throw UnsupportedOperationException.d8();
  }
  r1r($completion) {
    throw UnsupportedOperationException.d8();
  }
  s1p($completion) {
    return Unit_instance;
  }
}
class SliceAsyncStreamBase extends AsyncStreamBase {
  static f1s(base, baseStart, baseEnd, closeParent) {
    var $this = this.g1s();
    $this.a1s_1 = base;
    $this.b1s_1 = baseStart;
    $this.c1s_1 = baseEnd;
    $this.d1s_1 = closeParent;
    $this.e1s_1 = $this.c1s_1.a2($this.b1s_1);
    return $this;
  }
  z1r(position, buffer, offset, len, $completion) {
    var _destruct__k2r9zo = clampPositionLen(this, position, len);
    var targetStartPosition = _destruct__k2r9zo.jl();
    var targetLen = _destruct__k2r9zo.kl();
    return this.a1s_1.z1r(targetStartPosition, buffer, offset, targetLen, $completion);
  }
  h1s(position, buffer, offset, len, $completion) {
    var _destruct__k2r9zo = clampPositionLen(this, position, len);
    var targetStartPosition = _destruct__k2r9zo.jl();
    var targetLen = _destruct__k2r9zo.kl();
    return this.a1s_1.h1s(targetStartPosition, buffer, offset, targetLen, $completion);
  }
  r1r($completion) {
    return this.e1s_1;
  }
  s1p($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_close__nh2uv0_0.bind(VOID, this), $completion);
  }
  toString() {
    return 'SliceAsyncStreamBase(' + toString(this.a1s_1) + ', ' + this.b1s_1.toString() + ', ' + this.c1s_1.toString() + ')';
  }
}
class BufferedStreamBase extends AsyncStreamBase {
  static o1s(base, blockSize, blocksToRead) {
    blockSize = blockSize === VOID ? 2048 : blockSize;
    blocksToRead = blocksToRead === VOID ? 16 : blocksToRead;
    var $this = this.g1s();
    $this.i1s_1 = base;
    $this.j1s_1 = blockSize;
    $this.k1s_1 = blocksToRead;
    $this.l1s_1 = imul($this.j1s_1, $this.k1s_1);
    var tmp = $this;
    // Inline function 'kotlin.byteArrayOf' call
    tmp.m1s_1 = new Int8Array([]);
    $this.n1s_1 = new Long(-1, -1);
    return $this;
  }
  z1r(position, buffer, offset, len, $completion) {
    return this.p1s(position, buffer, offset, len, $completion);
  }
  toString() {
    return 'Buffered[' + this.k1s_1 + '*' + this.j1s_1 + ']:' + toString(this.i1s_1);
  }
  p1s(position, buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator__read__lo0dlr.bind(VOID, this, position, buffer, offset, len), $completion);
  }
  h1s(position, buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_2.bind(VOID, this, position, buffer, offset, len), $completion);
  }
  r1r($completion) {
    return this.i1s_1.r1r($completion);
  }
  s1p($completion) {
    return this.i1s_1.s1p($completion);
  }
}
class MemoryAsyncStreamBase extends AsyncStreamBase {
  static r1s(data) {
    var $this = this.g1s();
    $this.q1s_1 = data;
    return $this;
  }
  static s1s(initialCapacity) {
    initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
    return this.r1s(ByteArrayBuilder.bt(initialCapacity));
  }
  t1s() {
    return this.q1s_1.e1();
  }
  r1r($completion) {
    return toLong(this.t1s());
  }
  u1s(position) {
    if (position.z1(new Long(0, 0)) < 0)
      throw IllegalArgumentException.l('Invalid position ' + position.toString());
  }
  z1r(position, buffer, offset, len, $completion) {
    this.u1s(position);
    // Inline function 'kotlin.ranges.contains' call
    var this_0 = until(0, this.t1s());
    if (!contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), position))
      return 0;
    // Inline function 'kotlin.math.min' call
    var a = toLong(this.t1s());
    // Inline function 'kotlin.Long.plus' call
    var b = position.y3(toLong(len));
    var end = a.z1(b) <= 0 ? a : b;
    // Inline function 'kotlin.math.max' call
    var a_0 = end.a2(position).l2();
    var actualLen = Math.max(a_0, 0);
    arraycopy(this.q1s_1.xs_1, position.l2(), buffer, offset, actualLen);
    return actualLen;
  }
  h1s(position, buffer, offset, len, $completion) {
    this.u1s(position);
    var tmp = this.q1s_1;
    // Inline function 'kotlin.math.max' call
    var a = this.q1s_1.e1();
    // Inline function 'kotlin.Long.plus' call
    var b = position.y3(toLong(len)).l2();
    var tmp$ret$1 = Math.max(a, b);
    tmp.ct(tmp$ret$1);
    arraycopy(buffer, offset, this.q1s_1.xs_1, position.l2(), len);
  }
  s1p($completion) {
    return Unit_instance;
  }
  toString() {
    return 'MemoryAsyncStreamBase(' + this.q1s_1.e1() + ')';
  }
}
class AsyncPositionLengthStream {}
function hasAvailable($completion) {
  return this.s1r($completion);
}
function getAvailable($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_getAvailable__v3o1wr.bind(VOID, this), $completion);
}
class AsyncStream {
  constructor(base, position, queue) {
    position = position === VOID ? new Long(0, 0) : position;
    queue = queue === VOID ? false : queue;
    this.t1r_1 = new Mixin();
    this.u1r_1 = base;
    this.v1r_1 = position;
    this.w1r_1 = queue;
    this.x1r_1 = Mutex();
    this.y1r_1 = Mutex();
  }
  ay(_set____db54di) {
    this.t1r_1.ay(_set____db54di);
  }
  by() {
    return this.t1r_1.by();
  }
  toString() {
    return 'AsyncStream(' + toString(this.u1r_1) + ', position=' + this.v1r_1.toString() + ')';
  }
  r1p(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_2.bind(VOID, this, buffer, offset, len), $completion);
  }
  p1p(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_3.bind(VOID, this, buffer, offset, len), $completion);
  }
  s1r($completion) {
    return this.u1r_1.s1r($completion);
  }
  q1r($completion) {
    return this.v1r_1;
  }
  r1r($completion) {
    return this.u1r_1.r1r($completion);
  }
  s1p($completion) {
    return this.u1r_1.s1p($completion);
  }
}
class asyncStreamWriter$1$ensureJob$2$1 {
  constructor(this$0) {
    this.e1t_1 = this$0;
  }
  p1p(buffer, offset, len, $completion) {
    return this.e1t_1.z1s_1.p1p(buffer, offset, len, $completion);
  }
  s1p($completion) {
    return this.e1t_1.z1s_1.s1p($completion);
  }
}
class asyncStreamWriter$o$ensureJob$slambda {
  constructor($process, this$0) {
    this.x1s_1 = $process;
    this.y1s_1 = this$0;
  }
  g1o($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
  }
  vd(p1, $completion) {
    return this.g1o((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class asyncStreamWriter$1 {
  constructor($lazy, $bufferSize, $name, $process) {
    this.d1t_1 = $process;
    var tmp = this;
    var tmp_0;
    if ($lazy) {
      // Inline function 'kotlin.also' call
      var this_0 = new AsyncRingBuffer($bufferSize);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.io.stream.<no name provided>.deque.<anonymous>' call
      this_0.k1p_1 = $name;
      tmp_0 = this_0;
    } else {
      // Inline function 'kotlin.also' call
      var this_1 = new AsyncRingBufferChunked($bufferSize);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.io.stream.<no name provided>.deque.<anonymous>' call
      this_1.v1p_1 = $name;
      tmp_0 = this_1;
    }
    tmp.z1s_1 = tmp_0;
    this.a1t_1 = null;
    this.b1t_1 = null;
    this.c1t_1 = new Int8Array(1);
  }
  r1p(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_3.bind(VOID, this, buffer, offset, len), $completion);
  }
  s1p($completion) {
    var tmp14_safe_receiver = this.b1t_1;
    if (tmp14_safe_receiver == null)
      null;
    else {
      tmp14_safe_receiver.i16();
    }
    this.b1t_1 = null;
  }
}
class SyncLengthStream {}
class SyncStreamBase {
  static m1t() {
    var $this = createThis(this);
    $this.k1t_1 = new Int8Array(16);
    return $this;
  }
  o1t() {
    return false;
  }
  n1t(position, buffer, offset, len) {
    throw UnsupportedOperationException.d8();
  }
  p1t(position, buffer, offset, len) {
    throw UnsupportedOperationException.d8();
  }
  a() {
    throw UnsupportedOperationException.d8();
  }
  f6() {
    return Unit_instance;
  }
  q1t(position) {
    return new SyncStream(this, position);
  }
  l1t(position, $super) {
    position = position === VOID ? new Long(0, 0) : position;
    return $super === VOID ? this.q1t(position) : $super.q1t.call(this, position);
  }
  r1t(position) {
    return new SyncStream(this, position);
  }
  s1t(position, $super) {
    position = position === VOID ? new Long(0, 0) : position;
    return $super === VOID ? this.r1t(position) : $super.r1t.call(this, position);
  }
}
class ReadonlySyncStreamBase extends SyncStreamBase {
  static j1t(data, offset, size) {
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? data.length - offset | 0 : size;
    var $this = this.m1t();
    $this.g1t_1 = data;
    $this.h1t_1 = offset;
    $this.i1t_1 = size;
    return $this;
  }
  t1s() {
    return this.i1t_1;
  }
  a() {
    return toLong(this.g1t_1.length);
  }
  u1s(position) {
    if (position.z1(new Long(0, 0)) < 0) {
      invalidOp('Invalid position ' + position.toString());
    }
  }
  n1t(position, buffer, offset, len) {
    this.u1s(position);
    var ipos = position.l2();
    // Inline function 'kotlin.ranges.contains' call
    var this_0 = until(0, this.t1s());
    if (!contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), position))
      return 0;
    // Inline function 'kotlin.math.min' call
    var a = this.t1s();
    var b = ipos + len | 0;
    var end = Math.min(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = end - ipos | 0;
    var actualLen = Math.max(a_0, 0);
    arraycopy(this.g1t_1, ipos + this.h1t_1 | 0, buffer, offset, actualLen);
    return actualLen;
  }
  f6() {
    return Unit_instance;
  }
  toString() {
    return 'ReadonlySyncStreamBase(' + this.g1t_1.length + ')';
  }
}
class MemorySyncStreamBase extends SyncStreamBase {
  static v1t(data) {
    var $this = this.m1t();
    $this.u1t_1 = data;
    return $this;
  }
  static w1t(initialCapacity) {
    initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
    return this.v1t(ByteArrayBuilder.bt(initialCapacity));
  }
  t1s() {
    return this.u1t_1.e1();
  }
  a() {
    return toLong(this.u1t_1.e1());
  }
  u1s(position) {
    if (position.z1(new Long(0, 0)) < 0)
      throw IllegalArgumentException.l('Invalid position ' + position.toString());
  }
  n1t(position, buffer, offset, len) {
    this.u1s(position);
    var ipos = position.l2();
    // Inline function 'kotlin.ranges.contains' call
    var this_0 = until(0, this.t1s());
    if (!contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), position))
      return 0;
    // Inline function 'kotlin.math.min' call
    var a = this.t1s();
    var b = ipos + len | 0;
    var end = Math.min(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = end - ipos | 0;
    var actualLen = Math.max(a_0, 0);
    arraycopy(this.u1t_1.xs_1, ipos, buffer, offset, actualLen);
    return actualLen;
  }
  p1t(position, buffer, offset, len) {
    this.u1s(position);
    var tmp = this.u1t_1;
    // Inline function 'kotlin.math.max' call
    var a = this.u1t_1.e1();
    // Inline function 'kotlin.Long.plus' call
    var b = position.y3(toLong(len)).l2();
    var tmp$ret$1 = Math.max(a, b);
    tmp.ct(tmp$ret$1);
    arraycopy(buffer, offset, this.u1t_1.xs_1, position.l2(), len);
  }
  f6() {
    return Unit_instance;
  }
  toString() {
    return 'MemorySyncStreamBase(' + this.u1t_1.e1() + ')';
  }
}
class SyncInputStream {}
function read() {
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.stream.SyncInputStream.read.<anonymous>' call
  var it = new Int8Array(1);
  return this.y13(it, 0, 1) > 0 ? it[0] & 255 : -1;
}
class SyncPositionStream {}
class SyncOutputStream {}
function write(byte) {
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  var it = new Int8Array(1);
  it[0] = toByte(byte);
  this.d14(it, 0, 1);
  return Unit_instance;
}
class SyncStream {
  constructor(base, position) {
    position = position === VOID ? new Long(0, 0) : position;
    this.x1t_1 = new Mixin();
    this.y1t_1 = base;
    this.z1t_1 = this.y1t_1.k1t_1;
    this.a1u_1 = this.y1t_1.o1t();
    this.b1u_1 = position;
    this.c1u_1 = position;
    this.d1u_1 = position;
    this.e1u_1 = new Long(0, 0);
  }
  ay(_set____db54di) {
    this.x1t_1.ay(_set____db54di);
  }
  by() {
    return this.x1t_1.by();
  }
  f1u(value) {
    if (this.a1u_1)
      this.b1u_1 = value;
    else {
      this.g1u(value);
    }
  }
  h1u() {
    return this.a1u_1 ? this.b1u_1 : this.d1q();
  }
  i1u(value) {
    if (this.a1u_1)
      this.c1u_1 = value;
    else {
      this.g1u(value);
    }
  }
  j1u() {
    return this.a1u_1 ? this.c1u_1 : this.d1q();
  }
  g1u(value) {
    var tmp;
    if (this.a1u_1) {
      this.f1u(value);
      tmp = Unit_instance;
    } else {
      this.d1u_1 = value;
      tmp = Unit_instance;
    }
    return tmp;
  }
  d1q() {
    return this.a1u_1 ? this.h1u() : this.d1u_1;
  }
  y13(buffer, offset, len) {
    var read = this.y1t_1.n1t(this.h1u(), buffer, offset, len);
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$0 = this.h1u().y3(toLong(read));
    this.f1u(tmp$ret$0);
    return read;
  }
  k1u() {
    var size = this.y13(this.z1t_1, 0, 1);
    if (size <= 0)
      return -1;
    return this.z1t_1[0] & 255;
  }
  d14(buffer, offset, len) {
    this.y1t_1.p1t(this.j1u(), buffer, offset, len);
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$0 = this.j1u().y3(toLong(len));
    this.i1u(tmp$ret$0);
  }
  l1u(byte) {
    this.z1t_1[0] = toByte(byte);
    this.d14(this.z1t_1, 0, 1);
  }
  a() {
    return this.y1t_1.a();
  }
  f6() {
    return this.y1t_1.f6();
  }
  w13() {
    return this.a().a2(this.h1u());
  }
  aw() {
    return this.w13();
  }
  toString() {
    return 'SyncStream(' + toString(this.y1t_1) + ', ' + this.d1q().toString() + ')';
  }
}
class SliceSyncStreamBase extends SyncStreamBase {
  static r1u(base, baseStart, baseEnd) {
    var $this = this.m1t();
    $this.n1u_1 = base;
    $this.o1u_1 = baseStart;
    $this.p1u_1 = baseEnd;
    $this.q1u_1 = $this.p1u_1.a2($this.o1u_1);
    return $this;
  }
  o1t() {
    return this.n1u_1.o1t();
  }
  a() {
    return this.q1u_1;
  }
  n1t(position, buffer, offset, len) {
    var _destruct__k2r9zo = clampPositionLen_0(this, position, len);
    var targetStartPosition = _destruct__k2r9zo.jl();
    var targetLen = _destruct__k2r9zo.kl();
    return this.n1u_1.n1t(targetStartPosition, buffer, offset, targetLen);
  }
  p1t(position, buffer, offset, len) {
    var _destruct__k2r9zo = clampPositionLen_0(this, position, len);
    var targetStartPosition = _destruct__k2r9zo.jl();
    var targetLen = _destruct__k2r9zo.kl();
    return this.n1u_1.p1t(targetStartPosition, buffer, offset, targetLen);
  }
  f6() {
    return Unit_instance;
  }
  toString() {
    return 'SliceAsyncStreamBase(' + toString(this.n1u_1) + ', ' + this.o1u_1.toString() + ', ' + this.p1u_1.toString() + ')';
  }
}
//endregion
function *_generator_write__x1694l($this, buffer, offset, len, $completion) {
  if (len <= 0)
    return Unit_instance;
  if ($this.o1p_1) {
    // Inline function 'kotlin.error' call
    var message = 'Trying to write to a completed ' + $this.toString();
    throw IllegalStateException.z4(toString(message));
  }
  var tmp = $this.l1p_1.y1j($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.n1p_1.x13(buffer, offset, len);
  var tmp_0 = $this.m1p_1.u1j(Unit_instance, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_read__qih2oe($this, buffer, offset, len, $completion) {
  if (len <= 0)
    return len;
  if ($this.n1p_1.w13() > 0) {
    return $this.n1p_1.y13(buffer, offset, len);
  }
  var tmp = $this.l1p_1.u1j(Unit_instance, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  while (!$this.o1p_1 && $this.n1p_1.w13() === 0) {
    var tmp_0 = $this.m1p_1.y1j($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  if ($this.o1p_1 && $this.n1p_1.w13() === 0)
    return -1;
  return $this.n1p_1.y13(buffer, offset, len);
}
function *_generator_close__nh2uv0($this, $completion) {
  $this.o1p_1 = true;
  var tmp = $this.m1p_1.u1j(Unit_instance, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
function *_generator_waitToWriteMore__u7wb0w($this, len, $completion) {
  if ($this.w1p_1.c14_1 > $this.u1p_1) {
    while ($this.w1p_1.c14_1 > (1 + ($this.u1p_1 / 2 | 0) | 0)) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$0 = toDuration(1, DurationUnit_MILLISECONDS_getInstance());
      var tmp = delay(tmp$ret$0, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
  }
  return Unit_instance;
}
function waitToWriteMore($this, len, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_waitToWriteMore__u7wb0w.bind(VOID, $this, len), $completion);
}
function *_generator_write__x1694l_0($this, buffer, offset, len, $completion) {
  if (len <= 0)
    return Unit_instance;
  if ($this.x1p_1) {
    // Inline function 'kotlin.error' call
    var message = 'Trying to write to a completed ' + $this.toString();
    throw IllegalStateException.z4(toString(message));
  }
  var tmp = waitToWriteMore($this, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.w1p_1.d14(buffer, offset, len);
  return Unit_instance;
}
function *_generator_read__qih2oe_0($this, buffer, offset, len, $completion) {
  if (len <= 0)
    return 0;
  if (offset < 0 || (offset + len | 0) > buffer.length)
    throw OutOfBoundsException.ws();
  $l$loop: while (true) {
    var out = $this.w1p_1.y13(buffer, offset, len);
    if (out <= 0 && !$this.x1p_1) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$0 = toDuration(1, DurationUnit_MILLISECONDS_getInstance());
      var tmp = delay(tmp$ret$0, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      continue $l$loop;
    }
    return out;
  }
}
function offset($this, count) {
  var out = $this.b1q_1;
  $this.b1q_1 = $this.b1q_1 + count | 0;
  return out;
}
function openFastStream(_this__u8e3s4, offset) {
  offset = offset === VOID ? 0 : offset;
  return new FastByteArrayInputStream(_this__u8e3s4, offset);
}
var EMPTY_BYTE_ARRAY;
function toAsync(_this__u8e3s4, dispatcher) {
  dispatcher = dispatcher === VOID ? null : dispatcher;
  _init_properties_SyncAsync_ext_kt__inwu1q();
  return new toAsync$1(_this__u8e3s4, dispatcher);
}
function toAsync_0(_this__u8e3s4, dispatcher) {
  dispatcher = dispatcher === VOID ? null : dispatcher;
  _init_properties_SyncAsync_ext_kt__inwu1q();
  return new toAsync$2(_this__u8e3s4, dispatcher);
}
function *_generator_write__x1694l_1($this, buffer, offset, len, $completion) {
  // Inline function 'korlibs.io.stream.<no name provided>.doIo' call
  // Inline function 'korlibs.io.stream.doIo' call
  var dispatcher = $this.b1r_1;
  var tmp;
  if (!(dispatcher == null)) {
    var tmp_0 = withContext(dispatcher, toAsync$o$write$slambda_0($this, buffer, offset, len), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    $this.a1r_1.d14(buffer, offset, len);
    tmp = Unit_instance;
  }
  return Unit_instance;
}
function toAsync$o$write$slambda_0(this$0, $buffer, $offset, $len) {
  var i = new toAsync$o$write$slambda(this$0, $buffer, $offset, $len);
  var l = function ($this$withContext, $completion) {
    return i.g1o($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
function toAsync$o$close$slambda_1(this$0) {
  var i = new toAsync$o$close$slambda(this$0);
  var l = function ($this$launch, $completion) {
    return i.g1o($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_read__qih2oe_1($this, buffer, offset, len, $completion) {
  // Inline function 'korlibs.io.stream.<no name provided>.doIo' call
  // Inline function 'korlibs.io.stream.doIo' call
  var dispatcher = $this.i1r_1;
  var tmp;
  if (!(dispatcher == null)) {
    var tmp_0 = withContext(dispatcher, toAsync$o$read$slambda_0($this, buffer, offset, len), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    // Inline function 'korlibs.io.stream.<no name provided>.read.<anonymous>' call
    tmp = $this.h1r_1.y13(buffer, offset, len);
  }
  return tmp;
}
function *_generator_getPosition__nbsewl($this, $completion) {
  // Inline function 'korlibs.io.stream.<no name provided>.doIo' call
  // Inline function 'korlibs.io.stream.doIo' call
  var dispatcher = $this.i1r_1;
  var tmp;
  if (!(dispatcher == null)) {
    var tmp_0 = withContext(dispatcher, toAsync$o$getPosition$slambda_0($this), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    // Inline function 'korlibs.io.stream.<no name provided>.getPosition.<anonymous>' call
    var tmp_1 = $this.h1r_1;
    var tmp5_safe_receiver = isInterface(tmp_1, SyncPositionStream) ? tmp_1 : null;
    tmp = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.d1q();
  }
  var tmp0_elvis_lhs = tmp;
  var tmp_2;
  if (tmp0_elvis_lhs == null) {
    var tmp_3 = getPosition.call($this, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_2 = tmp_3;
  } else {
    tmp_2 = tmp0_elvis_lhs;
  }
  return tmp_2;
}
function *_generator_getLength__lvva94($this, $completion) {
  // Inline function 'korlibs.io.stream.<no name provided>.doIo' call
  // Inline function 'korlibs.io.stream.doIo' call
  var dispatcher = $this.i1r_1;
  var tmp;
  if (!(dispatcher == null)) {
    var tmp_0 = withContext(dispatcher, toAsync$o$getLength$slambda_0($this), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    // Inline function 'korlibs.io.stream.<no name provided>.getLength.<anonymous>' call
    var tmp_1 = $this.h1r_1;
    var tmp6_safe_receiver = isInterface(tmp_1, SyncLengthStream) ? tmp_1 : null;
    tmp = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.a();
  }
  var tmp0_elvis_lhs = tmp;
  var tmp_2;
  if (tmp0_elvis_lhs == null) {
    var tmp_3 = getLength.call($this, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_2 = tmp_3;
  } else {
    tmp_2 = tmp0_elvis_lhs;
  }
  return tmp_2;
}
function toAsync$o$read$slambda_0(this$0, $buffer, $offset, $len) {
  var i = new toAsync$o$read$slambda(this$0, $buffer, $offset, $len);
  var l = function ($this$withContext, $completion) {
    return i.g1o($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
function toAsync$o$close$slambda_2(this$0) {
  var i = new toAsync$o$close$slambda_0(this$0);
  var l = function ($this$launch, $completion) {
    return i.g1o($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function toAsync$o$getPosition$slambda_0(this$0) {
  var i = new toAsync$o$getPosition$slambda(this$0);
  var l = function ($this$withContext, $completion) {
    return i.g1o($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
function toAsync$o$getLength$slambda_0(this$0) {
  var i = new toAsync$o$getLength$slambda(this$0);
  var l = function ($this$withContext, $completion) {
    return i.g1o($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
var properties_initialized_SyncAsync_ext_kt_cwobuk;
function _init_properties_SyncAsync_ext_kt__inwu1q() {
  if (!properties_initialized_SyncAsync_ext_kt_cwobuk) {
    properties_initialized_SyncAsync_ext_kt_cwobuk = true;
    EMPTY_BYTE_ARRAY = new Int8Array(0);
  }
}
function *_generator_readLine__gnpvha(_this__u8e3s4, eol, charset, limit, initialCapacity, includeEnd, $completion) {
  eol = eol === VOID ? _Char___init__impl__6a9atx(10) : eol;
  charset = charset === VOID ? get_UTF8() : charset;
  limit = limit === VOID ? 2147483647 : limit;
  initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
  includeEnd = includeEnd === VOID ? false : includeEnd;
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(eol);
  var tmp = readUntil(_this__u8e3s4, toByte(tmp$ret$0), limit, initialCapacity, includeEnd, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return toString_1(tmp, charset);
}
function readLine(_this__u8e3s4, eol, charset, limit, initialCapacity, includeEnd, $completion) {
  eol = eol === VOID ? _Char___init__impl__6a9atx(10) : eol;
  charset = charset === VOID ? get_UTF8() : charset;
  limit = limit === VOID ? 2147483647 : limit;
  initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
  includeEnd = includeEnd === VOID ? false : includeEnd;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readLine__gnpvha.bind(VOID, _this__u8e3s4, eol, charset, limit, initialCapacity, includeEnd), $completion);
}
function *_generator_readU16BE__ml3dd9(_this__u8e3s4, $completion) {
  // Inline function 'korlibs.io.stream.readSmallTempExact' call
  var it = new Int8Array(2);
  var tmp = _this__u8e3s4.r1p(it, 0, 2, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var read = tmp;
  if (!(read === 2)) {
    // Inline function 'kotlin.error' call
    var message = "Couldn't read exact size=" + 2 + ' but read=' + read;
    throw IllegalStateException.z4(toString(message));
  }
  // Inline function 'korlibs.io.stream.readU16BE.<anonymous>' call
  return getU16BE(it, 0);
}
function readU16BE(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readU16BE__ml3dd9.bind(VOID, _this__u8e3s4), $completion);
}
function *_generator_readS32BE__lo15th(_this__u8e3s4, $completion) {
  // Inline function 'korlibs.io.stream.readSmallTempExact' call
  var it = new Int8Array(4);
  var tmp = _this__u8e3s4.r1p(it, 0, 4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var read = tmp;
  if (!(read === 4)) {
    // Inline function 'kotlin.error' call
    var message = "Couldn't read exact size=" + 4 + ' but read=' + read;
    throw IllegalStateException.z4(toString(message));
  }
  // Inline function 'korlibs.io.stream.readS32BE.<anonymous>' call
  return getS32BE(it, 0);
}
function readS32BE(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readS32BE__lo15th.bind(VOID, _this__u8e3s4), $completion);
}
function *_generator_readString__6uahun(_this__u8e3s4, len, charset, $completion) {
  charset = charset === VOID ? get_UTF8() : charset;
  var tmp = readBytesExact(_this__u8e3s4, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return toString_1(tmp, charset);
}
function readString(_this__u8e3s4, len, charset, $completion) {
  charset = charset === VOID ? get_UTF8() : charset;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readString__6uahun.bind(VOID, _this__u8e3s4, len, charset), $completion);
}
function *_generator_readU16__9pf7bk(_this__u8e3s4, endian, $completion) {
  var tmp;
  if (endian.equals(Endian_LITTLE_ENDIAN_getInstance())) {
    var tmp_0 = readU16LE(_this__u8e3s4, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    var tmp_1 = readU16BE(_this__u8e3s4, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = tmp_1;
  }
  return tmp;
}
function readU16(_this__u8e3s4, endian, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readU16__9pf7bk.bind(VOID, _this__u8e3s4, endian), $completion);
}
function *_generator_readS32__9pdyqg(_this__u8e3s4, endian, $completion) {
  var tmp;
  if (endian.equals(Endian_LITTLE_ENDIAN_getInstance())) {
    var tmp_0 = readS32LE(_this__u8e3s4, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    var tmp_1 = readS32BE(_this__u8e3s4, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = tmp_1;
  }
  return tmp;
}
function readS32(_this__u8e3s4, endian, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readS32__9pdyqg.bind(VOID, _this__u8e3s4, endian), $completion);
}
function *_generator_readStringz__10au0x(_this__u8e3s4, len, charset, $completion) {
  charset = charset === VOID ? get_UTF8() : charset;
  var tmp = readBytesExact(_this__u8e3s4, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var res = tmp;
  var index = indexOf(res, 0);
  return toString_1(copyOf(res, index < 0 ? len : index), charset);
}
function readStringz(_this__u8e3s4, len, charset, $completion) {
  charset = charset === VOID ? get_UTF8() : charset;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readStringz__10au0x.bind(VOID, _this__u8e3s4, len, charset), $completion);
}
function *_generator_readS32LE__lo1d8f(_this__u8e3s4, $completion) {
  // Inline function 'korlibs.io.stream.readSmallTempExact' call
  var it = new Int8Array(4);
  var tmp = _this__u8e3s4.r1p(it, 0, 4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var read = tmp;
  if (!(read === 4)) {
    // Inline function 'kotlin.error' call
    var message = "Couldn't read exact size=" + 4 + ' but read=' + read;
    throw IllegalStateException.z4(toString(message));
  }
  // Inline function 'korlibs.io.stream.readS32LE.<anonymous>' call
  return getS32LE(it, 0);
}
function readS32LE(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readS32LE__lo1d8f.bind(VOID, _this__u8e3s4), $completion);
}
function *_generator_readUntil__njr8lo(_this__u8e3s4, endByte, limit, initialCapacity, includeEnd, temp, $completion) {
  limit = limit === VOID ? 2147483647 : limit;
  initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
  includeEnd = includeEnd === VOID ? false : includeEnd;
  temp = temp === VOID ? new Int8Array(1) : temp;
  var out = ByteArrayBuilder.bt(initialCapacity);
  try {
    $l$loop_0: while (true) {
      var tmp = readExact(_this__u8e3s4, temp, 0, 1, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      var c = temp[0];
      if (c === endByte) {
        if (includeEnd) {
          // Inline function 'korlibs.memory.ByteArrayBuilder.append' call
          out.ft(c);
        }
        break $l$loop_0;
      }
      // Inline function 'korlibs.memory.ByteArrayBuilder.append' call
      out.ft(c);
      if (out.e1() >= limit)
        break $l$loop_0;
    }
  } catch ($p) {
    if ($p instanceof EOFException) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  return out.gt();
}
function readUntil(_this__u8e3s4, endByte, limit, initialCapacity, includeEnd, temp, $completion) {
  limit = limit === VOID ? 2147483647 : limit;
  initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
  includeEnd = includeEnd === VOID ? false : includeEnd;
  temp = temp === VOID ? new Int8Array(1) : temp;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readUntil__njr8lo.bind(VOID, _this__u8e3s4, endByte, limit, initialCapacity, includeEnd, temp), $completion);
}
function *_generator_readU16LE__ml3ks7(_this__u8e3s4, $completion) {
  // Inline function 'korlibs.io.stream.readSmallTempExact' call
  var it = new Int8Array(2);
  var tmp = _this__u8e3s4.r1p(it, 0, 2, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var read = tmp;
  if (!(read === 2)) {
    // Inline function 'kotlin.error' call
    var message = "Couldn't read exact size=" + 2 + ' but read=' + read;
    throw IllegalStateException.z4(toString(message));
  }
  // Inline function 'korlibs.io.stream.readU16LE.<anonymous>' call
  return getU16LE(it, 0);
}
function readU16LE(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readU16LE__ml3ks7.bind(VOID, _this__u8e3s4), $completion);
}
function skipToAlign(_this__u8e3s4, alignment, offset) {
  var tmp = _this__u8e3s4;
  // Inline function 'kotlin.Long.minus' call
  // Inline function 'kotlin.Long.plus' call
  var tmp$ret$0 = _this__u8e3s4.v1r_1.y3(toLong(offset));
  tmp.v1r_1 = nextAlignedTo(tmp$ret$0, toLong(alignment)).a2(toLong(offset));
}
function *_generator_readBytes__epy2u7(_this__u8e3s4, position, count, $completion) {
  var out = new Int8Array(count);
  var tmp = _this__u8e3s4.z1r(position, out, 0, out.length, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var readLen = tmp;
  return copyOf(out, readLen);
}
function readBytes(_this__u8e3s4, position, count, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBytes__epy2u7.bind(VOID, _this__u8e3s4, position, count), $completion);
}
function *_generator_sliceStart__7mxlrc(_this__u8e3s4, start, closeParent, $completion) {
  start = start === VOID ? new Long(0, 0) : start;
  closeParent = closeParent === VOID ? false : closeParent;
  var tmp = _this__u8e3s4.r1r($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = sliceWithBounds(_this__u8e3s4, start, tmp, closeParent, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function sliceStart(_this__u8e3s4, start, closeParent, $completion) {
  start = start === VOID ? new Long(0, 0) : start;
  closeParent = closeParent === VOID ? false : closeParent;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_sliceStart__7mxlrc.bind(VOID, _this__u8e3s4, start, closeParent), $completion);
}
function *_generator_sliceHere__xy500i(_this__u8e3s4, closeParent, $completion) {
  closeParent = closeParent === VOID ? false : closeParent;
  var tmp = _this__u8e3s4.v1r_1;
  var tmp_0 = _this__u8e3s4.r1r($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = sliceWithSize(_this__u8e3s4, tmp, tmp_0, closeParent, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function sliceHere(_this__u8e3s4, closeParent, $completion) {
  closeParent = closeParent === VOID ? false : closeParent;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_sliceHere__xy500i.bind(VOID, _this__u8e3s4, closeParent), $completion);
}
function *_generator_sliceWithBounds__ahw9dz(_this__u8e3s4, start, end, closeParent, $completion) {
  closeParent = closeParent === VOID ? false : closeParent;
  var tmp;
  var tmp_0 = _this__u8e3s4.s1r($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (tmp_0) {
    var tmp_1 = _this__u8e3s4.r1r($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = tmp_1;
  } else {
    tmp = end;
  }
  var rlen = tmp;
  var len = rlen.z1(new Long(0, 0)) >= 0 ? rlen : end;
  var clampedStart = coerceIn_0(start, new Long(0, 0), len);
  var clampedEnd = coerceIn_0(end, new Long(0, 0), len);
  var base = _this__u8e3s4.u1r_1;
  var tmp_2;
  if (base instanceof SliceAsyncStreamBase) {
    tmp_2 = SliceAsyncStreamBase.f1s(base.a1s_1, base.b1s_1.y3(clampedStart), base.b1s_1.y3(clampedEnd), closeParent);
  } else {
    tmp_2 = SliceAsyncStreamBase.f1s(_this__u8e3s4.u1r_1, clampedStart, clampedEnd, closeParent);
  }
  return toAsyncStream(tmp_2);
}
function sliceWithBounds(_this__u8e3s4, start, end, closeParent, $completion) {
  closeParent = closeParent === VOID ? false : closeParent;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_sliceWithBounds__ahw9dz.bind(VOID, _this__u8e3s4, start, end, closeParent), $completion);
}
function sliceWithSize(_this__u8e3s4, start, length, closeParent, $completion) {
  closeParent = closeParent === VOID ? false : closeParent;
  return sliceWithBounds(_this__u8e3s4, start, start.y3(length), closeParent, $completion);
}
function clampPosition($this, position) {
  return coerceIn_0(position, $this.b1s_1, $this.c1s_1);
}
function clampPositionLen($this, position, len) {
  if (position.z1(new Long(0, 0)) < 0)
    throw IllegalArgumentException.l('Invalid position');
  var targetStartPosition = clampPosition($this, $this.b1s_1.y3(position));
  // Inline function 'kotlin.Long.plus' call
  var tmp$ret$0 = targetStartPosition.y3(toLong(len));
  var targetEndPosition = clampPosition($this, tmp$ret$0);
  var targetLen = targetEndPosition.a2(targetStartPosition).l2();
  return new Pair(targetStartPosition, targetLen);
}
function *_generator_close__nh2uv0_0($this, $completion) {
  if ($this.d1s_1) {
    var tmp = $this.a1s_1.s1p($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function buffered(_this__u8e3s4, blockSize, blocksToRead) {
  blockSize = blockSize === VOID ? 2048 : blockSize;
  blocksToRead = blocksToRead === VOID ? 16 : blocksToRead;
  return toAsyncStream(BufferedStreamBase.o1s(_this__u8e3s4.u1r_1, blockSize, blocksToRead), _this__u8e3s4.v1r_1);
}
function *_generator__read__lo0dlr($this, position, buffer, offset, len, $completion) {
  var tmp;
  var tmp_0 = $this.i1s_1.s1r($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (tmp_0) {
    var tmp_1 = $this.i1s_1.r1r($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = position.z1(tmp_1) >= 0;
  } else {
    tmp = false;
  }
  if (tmp)
    return -1;
  // Inline function 'kotlin.Long.div' call
  var other = $this.l1s_1;
  var sector = position.a4(toLong(other));
  if (!$this.n1s_1.equals(sector)) {
    // Inline function 'kotlin.Long.times' call
    var other_0 = $this.l1s_1;
    var pos = sector.z3(toLong(other_0));
    var tmp_2;
    var tmp_3 = $this.i1s_1.s1r($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    if (tmp_3) {
      // Inline function 'kotlin.comparisons.minOf' call
      var a = toLong($this.l1s_1);
      var tmp_4 = $this.i1s_1.r1r($completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      var b = tmp_4.a2(pos);
      tmp_2 = (a.z1(b) <= 0 ? a : b).l2();
    } else {
      tmp_2 = $this.l1s_1;
    }
    var len_0 = tmp_2;
    var tmp_5 = $this;
    var tmp_6 = readBytes($this.i1s_1, pos, len_0, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    tmp_5.m1s_1 = tmp_6;
    $this.n1s_1 = sector;
  }
  // Inline function 'kotlin.Long.rem' call
  var other_1 = $this.l1s_1;
  var soffset = position.b4(toLong(other_1)).l2();
  var available = $this.m1s_1.length - soffset | 0;
  // Inline function 'kotlin.math.min' call
  var toRead = Math.min(available, len);
  arraycopy($this.m1s_1, soffset, buffer, offset, toRead);
  return toRead;
}
function *_generator_write__x1694l_2($this, position, buffer, offset, len, $completion) {
  var tmp = $this.i1s_1.h1s(position, buffer, offset, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function openAsync(_this__u8e3s4, mode) {
  mode = mode === VOID ? 'r' : mode;
  return toAsyncStream(MemoryAsyncStreamBase.r1s(ByteArrayBuilder.at(_this__u8e3s4, VOID, true)), new Long(0, 0));
}
function *_generator_readBytesExact__9z65vi(_this__u8e3s4, len, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = new Int8Array(len);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.stream.readBytesExact.<anonymous>' call
  var tmp = readExact(_this__u8e3s4, this_0, 0, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return this_0;
}
function readBytesExact(_this__u8e3s4, len, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBytesExact__9z65vi.bind(VOID, _this__u8e3s4, len), $completion);
}
function *_generator_hasLength__5f5ox8($this, $completion) {
  var tmp;
  try {
    var tmp_0 = $this.r1r($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0.z1(new Long(0, 0)) >= 0;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof UnsupportedOperationException) {
      var t = $p;
      tmp_1 = false;
    } else {
      throw $p;
    }
    tmp = tmp_1;
  }
  return tmp;
}
function *_generator_readAll__9p3omh(_this__u8e3s4, $completion) {
  var tmp;
  try {
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (isInterface(_this__u8e3s4, AsyncGetPositionStream)) {
      tmp_2 = isInterface(_this__u8e3s4, AsyncGetLengthStream);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      var tmp_3 = _this__u8e3s4.s1r($completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      tmp_1 = tmp_3;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      var tmp_4 = _this__u8e3s4.r1r($completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      var tmp_5 = _this__u8e3s4.q1r($completion);
      if (tmp_5 === get_COROUTINE_SUSPENDED())
        tmp_5 = yield tmp_5;
      var available = tmp_4.a2(tmp_5);
      var tmp_6 = readBytesExact(_this__u8e3s4, available.l2(), $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      tmp_0 = tmp_6;
    } else {
      var tmp_7;
      if (_this__u8e3s4 instanceof AsyncStream) {
        var tmp_8 = _this__u8e3s4.v1s($completion);
        if (tmp_8 === get_COROUTINE_SUSPENDED())
          tmp_8 = yield tmp_8;
        tmp_7 = tmp_8;
      } else {
        tmp_7 = false;
      }
      if (tmp_7) {
        var tmp_9 = _this__u8e3s4.w1s($completion);
        if (tmp_9 === get_COROUTINE_SUSPENDED())
          tmp_9 = yield tmp_9;
        var available_0 = tmp_9.l2();
        var tmp_10 = readBytesExact(_this__u8e3s4, available_0, $completion);
        if (tmp_10 === get_COROUTINE_SUSPENDED())
          tmp_10 = yield tmp_10;
        tmp_0 = tmp_10;
      } else {
        var out = ByteArrayBuilder.bt();
        // Inline function 'korlibs.io.stream.readChunks' call
        var temp = new Int8Array(1024);
        $l$loop: while (true) {
          var tmp_11 = _this__u8e3s4.r1p(temp, 0, temp.length, $completion);
          if (tmp_11 === get_COROUTINE_SUSPENDED())
            tmp_11 = yield tmp_11;
          var r = tmp_11;
          if (r <= 0)
            break $l$loop;
          // Inline function 'korlibs.io.stream.readAll.<anonymous>' call
          out.dt(temp, 0, r);
        }
        tmp_0 = out.gt();
      }
    }
    tmp = tmp_0;
  }finally {
    var tmp_12 = _this__u8e3s4.s1p($completion);
    if (tmp_12 === get_COROUTINE_SUSPENDED())
      tmp_12 = yield tmp_12;
  }
  return tmp;
}
function readAll(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readAll__9p3omh.bind(VOID, _this__u8e3s4), $completion);
}
function *_generator_read__qih2oe_2($this, buffer, offset, len, $completion) {
  var tmp;
  if ($this.w1r_1) {
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = $this.x1r_1;
    var tmp_0 = this_0.r1m(null, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp_1;
    try {
      // Inline function 'korlibs.io.stream.AsyncStream.read.<anonymous>' call
      var tmp_2 = readInternal($this, buffer, offset, len, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_1 = tmp_2;
    }finally {
      this_0.c1m(null);
    }
    tmp = tmp_1;
  } else {
    var tmp_3 = readInternal($this, buffer, offset, len, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp = tmp_3;
  }
  return tmp;
}
function *_generator_write__x1694l_3($this, buffer, offset, len, $completion) {
  if ($this.w1r_1) {
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = $this.y1r_1;
    var tmp = this_0.r1m(null, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0;
    try {
      var tmp_1 = writeInternal($this, buffer, offset, len, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp_0 = Unit_instance;
    }finally {
      this_0.c1m(null);
    }
  } else {
    var tmp_2 = writeInternal($this, buffer, offset, len, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  return Unit_instance;
}
function *_generator_readInternal__sbpouj($this, buffer, offset, len, $completion) {
  var tmp = $this.u1r_1.z1r($this.v1r_1, buffer, offset, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var read = tmp;
  if (read >= 0) {
    var tmp_0 = $this;
    // Inline function 'kotlin.Long.plus' call
    tmp_0.v1r_1 = $this.v1r_1.y3(toLong(read));
  }
  return read;
}
function readInternal($this, buffer, offset, len, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readInternal__sbpouj.bind(VOID, $this, buffer, offset, len), $completion);
}
function *_generator_writeInternal__u35gg8($this, buffer, offset, len, $completion) {
  var tmp = $this.u1r_1.h1s($this.v1r_1, buffer, offset, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this;
  // Inline function 'kotlin.Long.plus' call
  tmp_0.v1r_1 = $this.v1r_1.y3(toLong(len));
  return Unit_instance;
}
function writeInternal($this, buffer, offset, len, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_writeInternal__u35gg8.bind(VOID, $this, buffer, offset, len), $completion);
}
function toAsyncStream(_this__u8e3s4, position) {
  position = position === VOID ? new Long(0, 0) : position;
  return new AsyncStream(_this__u8e3s4, position);
}
function *_generator_readBytesUpTo__nh3xxl(_this__u8e3s4, len, $completion) {
  var BYTES_TEMP_SIZE = 4096;
  if (len <= BYTES_TEMP_SIZE) {
    var tmp = readBytesUpToCopy(_this__u8e3s4, new Int8Array(len), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    return tmp;
  }
  if (isInterface(_this__u8e3s4, AsyncPositionLengthStream)) {
    // Inline function 'kotlin.math.min' call
    var tmp_0 = _this__u8e3s4.w1s($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var b = toIntClamp(tmp_0);
    var tmp$ret$0 = Math.min(len, b);
    var tmp_1 = readBytesUpToCopy(_this__u8e3s4, new Int8Array(tmp$ret$0), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    return tmp_1;
  }
  var pending = len;
  var temp = new Int8Array(BYTES_TEMP_SIZE);
  var bout = ByteArrayBuilder.bt();
  $l$loop: while (pending > 0) {
    // Inline function 'kotlin.math.min' call
    var a = temp.length;
    var b_0 = pending;
    var tmp$ret$1 = Math.min(a, b_0);
    var tmp_2 = _this__u8e3s4.r1p(temp, 0, tmp$ret$1, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var read = tmp_2;
    if (read <= 0)
      break $l$loop;
    bout.dt(temp, 0, read);
    pending = pending - read | 0;
  }
  return bout.gt();
}
function readBytesUpTo(_this__u8e3s4, len, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBytesUpTo__nh3xxl.bind(VOID, _this__u8e3s4, len), $completion);
}
function *_generator_readBytesUpTo__nh3xxl_0(_this__u8e3s4, out, offset, len, $completion) {
  var total = 0;
  var pending = len;
  var offset_0 = offset;
  $l$loop: while (true) {
    var tmp = _this__u8e3s4.r1p(out, offset_0, pending, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var result = tmp;
    if (result <= 0)
      break $l$loop;
    offset_0 = offset_0 + result | 0;
    pending = pending - result | 0;
    total = total + result | 0;
  }
  return total;
}
function readBytesUpTo_0(_this__u8e3s4, out, offset, len, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBytesUpTo__nh3xxl_0.bind(VOID, _this__u8e3s4, out, offset, len), $completion);
}
function *_generator_readExact__g46z7v(_this__u8e3s4, buffer, offset, len, $completion) {
  var remaining = len;
  var coffset = offset;
  var reader = _this__u8e3s4;
  $l$loop: while (remaining > 0) {
    var tmp = reader.r1p(buffer, coffset, remaining, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var read = tmp;
    if (read < 0)
      break $l$loop;
    if (read === 0)
      throw EOFException.cv('Not enough data. Expected=' + len + ', Read=' + (len - remaining | 0) + ', Remaining=' + remaining);
    coffset = coffset + read | 0;
    remaining = remaining - read | 0;
  }
  return Unit_instance;
}
function readExact(_this__u8e3s4, buffer, offset, len, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readExact__g46z7v.bind(VOID, _this__u8e3s4, buffer, offset, len), $completion);
}
function *_generator_getAvailable__v3o1wr($this, $completion) {
  var tmp = $this.r1r($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.q1r($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp.a2(tmp_0);
}
function *_generator_readBytesUpToCopy__bi3svg(_this__u8e3s4, out, $completion) {
  var tmp = readBytesUpTo_0(_this__u8e3s4, out, 0, out.length, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var pos = tmp;
  return out.length === pos ? out : copyOf(out, pos);
}
function readBytesUpToCopy(_this__u8e3s4, out, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBytesUpToCopy__bi3svg.bind(VOID, _this__u8e3s4, out), $completion);
}
function asyncStreamWriter(bufferSize, name, lazy, process, $completion) {
  bufferSize = bufferSize === VOID ? 8388608 : bufferSize;
  name = name === VOID ? null : name;
  lazy = lazy === VOID ? false : lazy;
  return new asyncStreamWriter$1(lazy, bufferSize, name, process);
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  try {
    var tmp = $this.x1s_1(new asyncStreamWriter$1$ensureJob$2$1($this.y1s_1), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      $this.y1s_1.a1t_1 = e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  finally {
    var tmp_0 = $this.y1s_1.z1s_1.s1p($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
function checkException($this) {
  if (!($this.a1t_1 == null))
    throw RuntimeException.ce('Error in asyncStreamWriter : ' + toString_0($this.a1t_1), ensureNotNull($this.a1t_1));
}
function ensureJob($this, $completion) {
  if (!($this.b1t_1 == null))
    return Unit_instance;
  var tmp = $this;
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.rc();
  var tmp_0 = CoroutineScope_0(tmp$ret$0);
  tmp.b1t_1 = launch(tmp_0, VOID, VOID, asyncStreamWriter$o$ensureJob$slambda_0($this.d1t_1, $this));
}
function *_generator_read__qih2oe_3($this, buffer, offset, len, $completion) {
  var tmp = ensureJob($this, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  checkException($this);
  // Inline function 'kotlin.also' call
  var tmp_0 = $this.z1s_1.r1p(buffer, offset, len, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.stream.<no name provided>.read.<anonymous>' call
  return tmp_0;
}
function asyncStreamWriter$o$ensureJob$slambda_0($process, this$0) {
  var i = new asyncStreamWriter$o$ensureJob$slambda($process, this$0);
  var l = function ($this$launch, $completion) {
    return i.g1o($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function toSyncStream(_this__u8e3s4) {
  return ReadonlySyncStreamBase.j1t(_this__u8e3s4.y1p_1, _this__u8e3s4.z1p_1, _this__u8e3s4.a1q_1 - _this__u8e3s4.z1p_1 | 0).l1t();
}
function openSync(_this__u8e3s4, mode) {
  mode = mode === VOID ? 'r' : mode;
  return MemorySyncStreamBase.v1t(ByteArrayBuilder.at(_this__u8e3s4)).r1t(new Long(0, 0));
}
function MemorySyncStream(data) {
  return MemorySyncStreamBase.v1t(data).s1t();
}
function readS32BE_0(_this__u8e3s4) {
  return readU8(_this__u8e3s4) << 24 | readU8(_this__u8e3s4) << 16 | readU8(_this__u8e3s4) << 8 | readU8(_this__u8e3s4);
}
function readStringz_0(_this__u8e3s4, len) {
  var res = readBytes_0(_this__u8e3s4, len);
  var index = indexOf(res, 0);
  return decodeToString(copyOf(res, index < 0 ? len : index));
}
function readU8(_this__u8e3s4) {
  return _this__u8e3s4.k1u();
}
function readBytes_0(_this__u8e3s4, len) {
  var bytes = new Int8Array(len);
  var out = _this__u8e3s4.y13(bytes, 0, len);
  return !(out === len) ? copyOf(bytes, out) : bytes;
}
function readString_0(_this__u8e3s4, len, charset) {
  charset = charset === VOID ? get_UTF8() : charset;
  return toString_1(readBytes_0(_this__u8e3s4, len), charset);
}
function write8(_this__u8e3s4, v) {
  return _this__u8e3s4.l1u(v);
}
function get_eof(_this__u8e3s4) {
  return _this__u8e3s4.aw().z1(new Long(0, 0)) <= 0;
}
function readAll_0(_this__u8e3s4) {
  return readBytes_0(_this__u8e3s4, _this__u8e3s4.aw().l2());
}
function readStream(_this__u8e3s4, length) {
  return readSlice(_this__u8e3s4, length);
}
function sliceStart_0(_this__u8e3s4, start) {
  start = start === VOID ? new Long(0, 0) : start;
  return sliceWithBounds_0(_this__u8e3s4, start, _this__u8e3s4.a());
}
function readSlice(_this__u8e3s4, length) {
  // Inline function 'kotlin.apply' call
  var this_0 = sliceWithSize_0(_this__u8e3s4, _this__u8e3s4.d1q(), length);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.stream.readSlice.<anonymous>' call
  _this__u8e3s4.g1u(_this__u8e3s4.d1q().y3(length));
  return this_0;
}
function sliceWithBounds_0(_this__u8e3s4, start, end) {
  var len = _this__u8e3s4.a();
  var clampedStart = coerceIn_0(start, new Long(0, 0), len);
  var clampedEnd = coerceIn_0(end, new Long(0, 0), len);
  var base = _this__u8e3s4.y1t_1;
  if (base instanceof SliceSyncStreamBase) {
    return SliceSyncStreamBase.r1u(base.n1u_1, base.o1u_1.y3(clampedStart), base.o1u_1.y3(clampedEnd)).s1t();
  } else {
    return SliceSyncStreamBase.r1u(base, clampedStart, clampedEnd).s1t();
  }
}
function sliceWithSize_0(_this__u8e3s4, position, length) {
  return sliceWithBounds_0(_this__u8e3s4, position, position.y3(length));
}
function clampPosition_0($this, position) {
  return coerceIn_0(position, $this.o1u_1, $this.p1u_1);
}
function clampPositionLen_0($this, position, len) {
  if (position.z1(new Long(0, 0)) < 0)
    throw IllegalArgumentException.l('Invalid position');
  var targetStartPosition = clampPosition_0($this, $this.o1u_1.y3(position));
  // Inline function 'kotlin.Long.plus' call
  var tmp$ret$0 = targetStartPosition.y3(toLong(len));
  var targetEndPosition = clampPosition_0($this, tmp$ret$0);
  var targetLen = targetEndPosition.a2(targetStartPosition).l2();
  return new Pair(targetStartPosition, targetLen);
}
//region block: post-declaration
initMetadataForInterface(AsyncOutputStream, 'AsyncOutputStream', VOID, VOID, VOID, [3, 1, 0]);
protoOf(AsyncRingBuffer).q1p = write$default;
initMetadataForClass(AsyncRingBuffer, 'AsyncRingBuffer', AsyncRingBuffer, VOID, [AsyncOutputStream], [3, 0, 1]);
initMetadataForCompanion(Companion);
protoOf(AsyncRingBufferChunked).q1p = write$default;
initMetadataForClass(AsyncRingBufferChunked, 'AsyncRingBufferChunked', AsyncRingBufferChunked, VOID, [AsyncOutputStream], [1, 3, 0]);
initMetadataForClass(FastByteArrayInputStream, 'FastByteArrayInputStream');
initMetadataForLambda(toAsync$o$write$slambda, VOID, VOID, [1]);
initMetadataForLambda(toAsync$o$close$slambda, VOID, VOID, [1]);
protoOf(toAsync$1).q1p = write$default;
initMetadataForClass(toAsync$1, VOID, VOID, VOID, [AsyncOutputStream], [1, 3, 0]);
initMetadataForLambda(toAsync$o$read$slambda, VOID, VOID, [1]);
initMetadataForLambda(toAsync$o$close$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(toAsync$o$getPosition$slambda, VOID, VOID, [1]);
initMetadataForLambda(toAsync$o$getLength$slambda, VOID, VOID, [1]);
initMetadataForInterface(AsyncGetLengthStream, 'AsyncGetLengthStream', VOID, VOID, VOID, [0]);
initMetadataForInterface(AsyncGetPositionStream, 'AsyncGetPositionStream', VOID, VOID, VOID, [0]);
protoOf(toAsync$2).s1r = hasLength;
initMetadataForClass(toAsync$2, VOID, VOID, VOID, [AsyncGetLengthStream, AsyncGetPositionStream], [1, 3, 0]);
protoOf(AsyncStreamBase).s1r = hasLength;
initMetadataForClass(AsyncStreamBase, 'AsyncStreamBase', AsyncStreamBase.g1s, VOID, [AsyncGetLengthStream], [4, 1, 0]);
initMetadataForClass(SliceAsyncStreamBase, 'SliceAsyncStreamBase', VOID, VOID, VOID, [4, 0, 1]);
initMetadataForClass(BufferedStreamBase, 'BufferedStreamBase', VOID, VOID, VOID, [4, 1, 0]);
initMetadataForClass(MemoryAsyncStreamBase, 'MemoryAsyncStreamBase', MemoryAsyncStreamBase.s1s, VOID, VOID, [1, 0, 4]);
initMetadataForInterface(AsyncPositionLengthStream, 'AsyncPositionLengthStream', VOID, VOID, [AsyncGetPositionStream, AsyncGetLengthStream], [0, 1]);
protoOf(AsyncStream).q1p = write$default;
protoOf(AsyncStream).v1s = hasAvailable;
protoOf(AsyncStream).w1s = getAvailable;
initMetadataForClass(AsyncStream, 'AsyncStream', VOID, VOID, [AsyncGetLengthStream, AsyncGetPositionStream, AsyncOutputStream, AsyncPositionLengthStream], [3, 0, 1]);
protoOf(asyncStreamWriter$1$ensureJob$2$1).q1p = write$default;
initMetadataForClass(asyncStreamWriter$1$ensureJob$2$1, VOID, VOID, VOID, [AsyncOutputStream], [3, 1, 0]);
initMetadataForLambda(asyncStreamWriter$o$ensureJob$slambda, VOID, VOID, [1]);
initMetadataForClass(asyncStreamWriter$1, VOID, VOID, VOID, VOID, [0, 3]);
initMetadataForInterface(SyncLengthStream, 'SyncLengthStream');
initMetadataForClass(SyncStreamBase, 'SyncStreamBase', SyncStreamBase.m1t, VOID, [AutoCloseable, SyncLengthStream]);
initMetadataForClass(ReadonlySyncStreamBase, 'ReadonlySyncStreamBase');
initMetadataForClass(MemorySyncStreamBase, 'MemorySyncStreamBase', MemorySyncStreamBase.w1t);
initMetadataForInterface(SyncInputStream, 'SyncInputStream', VOID, VOID, [AutoCloseable]);
initMetadataForInterface(SyncPositionStream, 'SyncPositionStream');
initMetadataForInterface(SyncOutputStream, 'SyncOutputStream', VOID, VOID, [AutoCloseable]);
initMetadataForClass(SyncStream, 'SyncStream', VOID, VOID, [AutoCloseable, SyncInputStream, SyncPositionStream, SyncOutputStream, SyncLengthStream]);
initMetadataForClass(SliceSyncStreamBase, 'SliceSyncStreamBase');
//endregion
//region block: init
Companion_instance = new Companion();
//endregion
//region block: exports
export {
  asyncStreamWriter as asyncStreamWriter3ock1ljgyrdbd,
  readAll as readAll1pkrq4jwoqns4,
  readBytesExact as readBytesExact305h8zdeltghk,
  readBytesUpTo as readBytesUpTo2jsx0o5buj2sw,
  readLine as readLine1dpyp1tbzc63w,
  readS32 as readS325wl7ebgpu38s,
  readStringz as readStringzzxx8hll1ncys,
  readString as readString3h14fm47a2tde,
  readU16 as readU162q6ft3yjssyvs,
  sliceHere as sliceHere162e6oimkowhf,
  sliceStart as sliceStart186j1d4dpd1wx,
  write$default as write$default33b74pnsnzha9,
  AsyncGetLengthStream as AsyncGetLengthStream219k26r6v6js2,
  AsyncGetPositionStream as AsyncGetPositionStream2f8n5516y4rp7,
  AsyncOutputStream as AsyncOutputStreamkoco1dsjo5gm,
  AsyncStreamBase as AsyncStreamBaseze8sfl15nwf0,
  FastByteArrayInputStream as FastByteArrayInputStream1jjm4ufd0tkh5,
  MemorySyncStream as MemorySyncStream1uv927me2xl9s,
  buffered as buffered29ldm4q6ez2xm,
  get_eof as get_eofaukbsoaf5jcj,
  openAsync as openAsync37anb1e84urmo,
  openFastStream as openFastStream2r4uuohoj0wpo,
  openSync as openSync2m3qn99fqytu0,
  readAll_0 as readAll3m5rixujsbctr,
  readBytes_0 as readBytes3l26albs0coyl,
  readS32BE_0 as readS32BE1vkzsiuy9pof1,
  readStream as readStream3s64ivrsklqly,
  readStringz_0 as readStringz3jxaogr49n5ys,
  readString_0 as readString3106ot9qwcir2,
  readU8 as readU82o15i0epsnmc5,
  skipToAlign as skipToAlignusebk6ndjvs1,
  sliceStart_0 as sliceStart237tx6t7cytus,
  toAsyncStream as toAsyncStream3ow20wz4trxzb,
  toAsync_0 as toAsync26jtc2k5wi4gn,
  toAsync as toAsync2pa2d6thtq8t4,
  toSyncStream as toSyncStream3g0dpktigjx33,
  write8 as write81fg3kayjaelgo,
};
//endregion
